import { cn } from '@/lib/utils'

/*
 * VisitOne product mark: an emerald tile with an asymmetric lower-left corner
 * and a white monogram. This is the system's own wordmark treatment; as a
 * logotype it is exempt from the WCAG 1.4.3 contrast minimum.
 */
function ProductMark({
  showName = true,
  className,
}: {
  showName?: boolean
  className?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span
        {...(showName ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'VisitOne' })}
        data-slot="product-mark"
        className="inline-flex size-8 items-center justify-center bg-accent text-sm font-semibold text-white"
        style={{ borderRadius: '10px 10px 10px 3px' }}
      >
        V
      </span>
      {showName ? (
        <span className="text-sm font-semibold text-fg-strong">VisitOne</span>
      ) : null}
    </span>
  )
}

export { ProductMark }
